'use strict';

var _ = require('lodash');
var ThematicBarChartDataProviderService = function ThematicBarChartDataProviderService(dataRetrieverService, analysisMetricService, representationService) {
  function getSelectedMetric(screen, mode) {
    var dataRetriever = dataRetrieverService.getDataRetriever(screen, mode);
    var analysisMetric = analysisMetricService.getAnalysisMetric(screen);
    var labels = analysisMetric.getAvailableLabels(mode);
    return _.find(labels, {
      id: dataRetriever.selectedMetric()
    });
  }
  function prepareData(dataRepresentation, data, metric) {
    data = _.cloneDeep(data);
    return data.map(function (item) {
      item.d1 = item.label;
      item.stackLabel = item.label;
      return metric === 'loadFactor' ? representationService.prepareLFChartBarMetricsInAbsolute(item, dataRepresentation) : representationService.prepareChartBarMetrics(item, dataRepresentation);
    });
  }
  function getData(screen, mode, type) {
    var metric = dataRetrieverService.getDataRetriever(screen, mode).selectedMetric();
    return dataRetrieverService.getDataRetriever(screen, mode).retrieveComponentData(type).then(function (data) {
      if (data && data.length) {
        return {
          absolute: prepareData('absolute', data, metric),
          percentage: prepareData('percentage', data, metric)
        };
      }
    }, function () {
      return [];
    });
  }
  return {
    getData: getData,
    getSelectedMetric: getSelectedMetric
  };
};
ThematicBarChartDataProviderService.$inject = ['DataRetrieverService', 'AnalysisMetricService', 'DataRepresentationService'];
module.exports = ThematicBarChartDataProviderService;